import { useEffect } from 'react';

import { user } from 'core';
import { useHistory } from 'react-router-dom';
import config from 'config';
import { BUSINESS_UNITS } from 'core/domains';
import { useRouteSettings } from 'core/use-cases/settings/hooks';
import { Routes } from 'core/domains/settings';

export const useRedirectBlockedUser = () => {
  const history = useHistory();
  const {
    data: { isBlocked, isMultiBrand, isResaleIntention },
  } = user.hooks.useUser();
  const isEud = config.app.short === BUSINESS_UNITS.EUD.toLowerCase();
  const { canBlockedResellerAccess, isPrivate } = useRouteSettings() as Routes;

  useEffect(() => {
    if (!isPrivate) {
      return;
    }
    if (isResaleIntention) {
      return;
    }

    if (canBlockedResellerAccess) {
      return;
    }

    if (!canBlockedResellerAccess && isBlocked && isEud && isMultiBrand) {
      history.push('/revendedores-grupoboticario');
      return;
    }

    if (!canBlockedResellerAccess && isBlocked) {
      history.push('/403');
      return;
    }
  }, [history.location.pathname]);
};
